import { Col, Tab } from '@rematter/ui-web';

import { useSettingsLocation } from '../../_state/settingsModule.state';
import { SettingsSubmodule } from '../_layouts/SettingsSubmodule';

import { LocationGroupList } from './LocationGroupList';
import { LocationList } from './LocationList';

export const LocationsRootView = () => {
  const [location, setLocation] = useSettingsLocation();

  const isFacilitiesLocation = location === '/locations/facilities';
  const isGroupsLocation = location === '/locations/groups';

  return (
    <Col className="@LocationsRootView h-full">
      <SettingsSubmodule
        title="Locations"
        subtitle="Create and manage your locations"
        tabs={
          <>
            <Tab
              selected={isFacilitiesLocation}
              onClick={() => setLocation('/locations/facilities')}
            >
              Facilities
            </Tab>
            <Tab
              selected={isGroupsLocation}
              onClick={() => setLocation('/locations/groups')}
            >
              Groups
            </Tab>
          </>
        }
      >
        {isFacilitiesLocation && <LocationList />}
        {isGroupsLocation && <LocationGroupList />}
      </SettingsSubmodule>
    </Col>
  );
};
